import { Injectable } from '@angular/core';
import { IIDolCommunicationStore } from './iidOlCommunication.store';
import { IID_OL_COMMUNICATION } from '@common/interfaces/interfaceData';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { IIDolCommunicationQuery } from './iidOlCommunication.query'
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { WsACKCallback } from '@common/api/ack';
import { PartialUpdate } from '@common/interfaces/base';
import { RealtimeFeatureCommandService } from '@ep-om/realtime-v2';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

const TOPIC = Topics.IID_OL_COMMUNICATION;
@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.OLO_COMMUNICATION)
export class IIDolCommunicationService extends CrudService<IID_OL_COMMUNICATION, IIDolCommunicationStore, IIDolCommunicationQuery> {
  constructor(
    protected store: IIDolCommunicationStore,
    public query: IIDolCommunicationQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
    private featureCommandService: RealtimeFeatureCommandService,
  ) {
    super(
      TOPIC,
      store,
      query,
      actionService,
      updateStrategy
    );
  }

  retry(id: string, callback?: WsACKCallback) {
    const dto = { id };
    this.featureCommandService.send(
      {
        target: 'feature:ol-communication',
        command: 'retry',
        dto,
        ...this.projectIdFromEntity(id),
      },
      () => this.actionService.sendMessage(TOPIC, 'retry', dto, callback),
      callback,
    );
  }

  private projectIdFromEntity(id: string): { projectId?: string } {
    const projectId = this.query.getEntity(id)?.projectId;
    return projectId ? { projectId } : {};
  }
}
